document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Sticky nav background on scroll ---------- */
  var nav = document.getElementById('mainNav');
  var backToTop = document.getElementById('backToTop');

  function onScroll() {
    if (nav) {
      if (window.scrollY > 60) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    }
    if (backToTop) {
      if (window.scrollY > 700) {
        backToTop.classList.add('show');
      } else {
        backToTop.classList.remove('show');
      }
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile nav toggle ---------- */
  var navToggle = document.getElementById('navToggle');
  var navList = document.getElementById('navList');
  if (navToggle && navList) {
    navToggle.addEventListener('click', function () {
      var isOpen = navList.classList.toggle('open');
      navToggle.innerHTML = isOpen ? '<i class="fa-solid fa-xmark"></i>' : '<i class="fa-solid fa-bars"></i>';
    });
    navList.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        navList.classList.remove('open');
        navToggle.innerHTML = '<i class="fa-solid fa-bars"></i>';
      });
    });
  }

  /* ---------- Scrollspy: highlight active nav link ---------- */
  var sections = document.querySelectorAll('section[id], header[id]');
  var navLinks = document.querySelectorAll('.katche-nav .nav-link');

  var spy = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var id = entry.target.getAttribute('id');
        navLinks.forEach(function (link) {
          link.classList.toggle('active', link.getAttribute('href') === '#' + id);
        });
      }
    });
  }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });

  sections.forEach(function (sec) { spy.observe(sec); });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  revealEls.forEach(function (el) { revealObserver.observe(el); });

  /* ---------- Feature card accordion (Iconic Sessions intro) ---------- */
  document.querySelectorAll('.feature-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var wasOpen = card.classList.contains('is-open');
      document.querySelectorAll('.feature-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
      if (!wasOpen) card.classList.add('is-open');
    });
  });

  /* ---------- Bio popups (artists + staff) ---------- */
  var bioMobileQuery = window.matchMedia('(max-width: 640px)');
  var bioPairs = Array.prototype.map.call(document.querySelectorAll('.bio-btn'), function (btn) {
    var pop = btn.nextElementSibling;
    return { btn: btn, pop: pop, parent: pop.parentNode, next: pop.nextSibling };
  });

  function closeAllBioPops() {
    bioPairs.forEach(function (pair) {
      pair.pop.classList.remove('show');
      pair.pop.style.top = '';
      pair.pop.style.left = '';
      pair.btn.classList.remove('active');
      // Restore DOM position so desktop's ".bio-btn:hover + .bio-pop" selector still matches.
      if (pair.pop.parentNode !== pair.parent) {
        pair.parent.insertBefore(pair.pop, pair.next);
      }
    });
  }

  function positionBioPop(pair) {
    if (!bioMobileQuery.matches) return;
    // Reparent to <body> so a transformed ancestor (.skew-top) can't hijack the fixed-position containing block.
    document.body.appendChild(pair.pop);
    var margin = 16;
    var btnRect = pair.btn.getBoundingClientRect();
    var popRect = pair.pop.getBoundingClientRect();
    var left = (window.innerWidth - popRect.width) / 2;
    var top = btnRect.top - popRect.height - 12;
    if (top < margin) top = btnRect.bottom + 12;
    top = Math.max(margin, Math.min(top, window.innerHeight - popRect.height - margin));
    pair.pop.style.left = left + 'px';
    pair.pop.style.top = top + 'px';
  }

  var bioOpenScrollY = 0;
  bioPairs.forEach(function (pair) {
    pair.btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = pair.pop.classList.contains('show');
      closeAllBioPops();
      if (!isOpen) {
        positionBioPop(pair);
        pair.pop.classList.add('show');
        pair.btn.classList.add('active');
        bioOpenScrollY = window.scrollY;
      }
    });
  });
  // Ignore incidental scroll events (address-bar collapse) right after opening.
  window.addEventListener('scroll', function () {
    if (Math.abs(window.scrollY - bioOpenScrollY) > 4) closeAllBioPops();
  }, { passive: true });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.bio-btn') || e.target.closest('.bio-pop')) return;
    closeAllBioPops();
  });

  /* ---------- Artist testimonials: tap to reveal on touch devices ---------- */
  document.querySelectorAll('.artist-card').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.bio-btn')) return;
      var wasOpen = card.classList.contains('is-open');
      document.querySelectorAll('.artist-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
      if (!wasOpen) card.classList.add('is-open');
    });
  });

  /* ---------- Hero video: sound toggle + reduced motion ---------- */
  var heroVideo = document.querySelector('.hero-video');
  var soundToggle = document.getElementById('soundToggle');
  if (heroVideo) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroVideo.removeAttribute('autoplay');
      heroVideo.pause();
    }
    if (soundToggle) {
      soundToggle.addEventListener('click', function () {
        heroVideo.muted = !heroVideo.muted;
        if (!heroVideo.muted) {
          heroVideo.play();
          soundToggle.innerHTML = '<i class="fa-solid fa-volume-high"></i>';
          soundToggle.setAttribute('aria-label', 'Turn sound off');
        } else {
          soundToggle.innerHTML = '<i class="fa-solid fa-volume-xmark"></i>';
          soundToggle.setAttribute('aria-label', 'Turn sound on');
        }
      });
    }
  }

  /* ---------- Guarantee single-line fit for tagline + cities-line, regardless of font rendering ---------- */
  var fitTargets = document.querySelectorAll('.online-copy .tagline, .one-line-fit');
  function fitOneLine(el) {
    el.style.transform = 'none';
    var parentWidth = el.parentElement.clientWidth;
    var textWidth = el.scrollWidth;
    if (textWidth > parentWidth && textWidth > 0 && parentWidth > 0) {
      var scale = parentWidth / textWidth * 0.98;
      el.style.transform = 'scale(' + scale.toFixed(3) + ')';
    }
  }
  function fitAll() {
    fitTargets.forEach(fitOneLine);
  }
  if (fitTargets.length) {
    fitAll();
    window.addEventListener('resize', fitAll);
    window.addEventListener('load', fitAll);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAll).catch(function () {});
    }
    [50, 150, 300, 600, 1000, 2000].forEach(function (delay) {
      setTimeout(fitAll, delay);
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { fitAll(); });
      fitTargets.forEach(function (el) { ro.observe(el.parentElement); });
    }
  }

  /* ---------- Waitlist form ---------- */
  var wlForm = document.getElementById('waitlistForm');
  if (wlForm) {
    // Pre-check the relevant interest checkbox if arriving via ?session=paris|la|tokyo|vip|online
    var params = new URLSearchParams(window.location.search);
    var sessionParam = (params.get('session') || '').toLowerCase();
    var interestMap = { paris: 'int-sessions', la: 'int-sessions', 'los-angeles': 'int-sessions', tokyo: 'int-sessions', vip: 'int-vip' };
    if (sessionParam in interestMap) {
      var pre = document.getElementById(interestMap[sessionParam]);
      if (pre) pre.checked = true;
    }
    var addonParam = (params.get('addon') || '').toLowerCase();
    if (addonParam.indexOf('signature') !== -1) {
      var cc = document.getElementById('int-signature');
      if (cc) cc.checked = true;
    }

    // On submit, this form posts for real to Shopify (form 'customer'),
    // creating/updating a Customer record with accepts_marketing = true —
    // that's the marketing database. Shopify only persists email + tags
    // from this endpoint, so we build the tags string here from the
    // checkboxes/radio, and separately beacon the free-text details
    // (name, country, phone) to the contact-form notification email so
    // nothing the visitor typed is lost.
    wlForm.addEventListener('submit', function () {
      var interestBoxes = [].slice.call(wlForm.querySelectorAll('input[name="interest"]:checked'));
      var interests = interestBoxes.map(function (b) { return b.value; });
      var levelBox = wlForm.querySelector('input[name="level"]:checked');
      var level = levelBox ? levelBox.value : '';

      var tags = ['waitlist'];
      interestBoxes.forEach(function (b) { tags.push('interest-' + b.id.replace(/^int-/, '')); });
      if (level) tags.push('level-' + level.toLowerCase().replace(/[^a-z]+/g, '-'));
      var tagsField = document.getElementById('wl-tags');
      if (tagsField) tagsField.value = tags.join(', ');

      if (navigator.sendBeacon) {
        var name = document.getElementById('wl-name').value.trim();
        var email = document.getElementById('wl-email').value.trim();
        var country = document.getElementById('wl-country').value.trim();
        var phone = document.getElementById('wl-phone').value.trim();

        var data = new URLSearchParams();
        data.append('form_type', 'contact');
        data.append('utf8', '✓');
        data.append('contact[email]', email);
        data.append('contact[Name]', name);
        data.append('contact[Country / City]', country);
        data.append('contact[Phone]', phone);
        data.append('contact[Interested in]', interests.join(', ') || 'Not specified');
        data.append('contact[Level]', level || 'Not specified');
        data.append('contact[body]', 'Register Interest form — full details.');
        navigator.sendBeacon('/contact', data);
      }
    });
  }

  /* ---------- Path Compare: reveal / collapse the full detail panels ---------- */
  document.querySelectorAll('.pc-reveal').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(link.getAttribute('data-target'));
      if (!target) return;
      target.classList.add('open');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  document.querySelectorAll('.pc-collapse').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(link.getAttribute('data-target'));
      var compare = document.getElementById('path-compare');
      if (target) target.classList.remove('open');
      if (compare) compare.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Section quick-nav: highlight active section on scroll ---------- */
  var quicknav = document.getElementById('sectionQuicknav');
  if (quicknav) {
    var qnLinks = quicknav.querySelectorAll('a');
    var qnTargets = [];
    qnLinks.forEach(function (link) {
      var id = link.getAttribute('href').replace('#', '');
      var el = document.getElementById(id);
      if (el) qnTargets.push({ link: link, el: el });
    });
    var qnObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var match = qnTargets.find(function (t) { return t.el === entry.target; });
        if (!match) return;
        if (entry.isIntersecting) {
          qnLinks.forEach(function (l) { l.classList.remove('active'); });
          match.link.classList.add('active');
        }
      });
    }, { rootMargin: '-200px 0px -60% 0px', threshold: 0 });
    qnTargets.forEach(function (t) { qnObserver.observe(t.el); });
  }

  /* ---------- Pricing & Options: select-then-confirm flow ---------- */
  var finalBar = document.getElementById('finalCtaBar');
  if (finalBar) {
    var selectedPackage = null;   // 'double' | 'single' | 'self'
    var selectedAddons = {};      // { signature: 'label', video: 'label' }
    var fcbItems = document.getElementById('fcbItems');
    var fcbTotal = document.getElementById('fcbTotal');
    var finalClaimBtn = document.getElementById('finalClaimBtn');
    var sessionParamPage = finalClaimBtn.getAttribute('href').match(/session=([a-z]+)/)[1];

    function packageLabel(key) {
      return { double: 'Double Occupancy for 2', single: 'Single Occupancy', self: 'Self-Accommodation' }[key];
    }

    function priceToNumber(str) {
      if (!str) return 0;
      var n = parseFloat(String(str).replace(/[^0-9.]/g, ''));
      return isNaN(n) ? 0 : n;
    }

    function updateSummary() {
      var parts = [];
      if (selectedPackage) parts.push('Iconic Session (' + packageLabel(selectedPackage) + ')');
      Object.keys(selectedAddons).forEach(function (k) { parts.push(selectedAddons[k]); });
      if (!selectedPackage) {
        fcbItems.textContent = 'No package selected yet — choose one above.';
      } else {
        fcbItems.textContent = parts.join('  +  ');
      }

      // Estimated running total from data-price attributes (Early Bird / placeholder rates)
      var total = 0;
      if (selectedPackage) {
        var pkgBtn = document.querySelector('.pkg-select-btn[data-package="' + selectedPackage + '"]');
        if (pkgBtn) total += priceToNumber(pkgBtn.getAttribute('data-price'));
      }
      document.querySelectorAll('.opt-select-btn.is-selected').forEach(function (b) {
        total += priceToNumber(b.getAttribute('data-price'));
      });
      if (fcbTotal) {
        if (selectedPackage) {
          fcbTotal.textContent = 'Estimated total: €' + total + ' — your seat is pre-reserved; final pricing and terms will be shared shortly after your waitlist registration.';
          fcbTotal.style.display = 'block';
        } else {
          fcbTotal.style.display = 'none';
        }
      }

      // Build the final URL
      var url = 'waitlist.html?session=' + sessionParamPage;
      if (selectedPackage) url += '&package=' + selectedPackage;
      var addonKeys = Object.keys(selectedAddons);
      if (addonKeys.length) url += '&addon=' + addonKeys.join(',');
      finalClaimBtn.setAttribute('href', url);
      finalClaimBtn.classList.toggle('disabled', !selectedPackage);
    }

    document.querySelectorAll('.pkg-select-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-package');
        document.querySelectorAll('.pkg-select-btn').forEach(function (b) {
          b.classList.remove('is-selected');
          b.textContent = 'Select This Package';
          b.closest('.price-card').classList.remove('pkg-selected');
        });
        btn.classList.add('is-selected');
        btn.innerHTML = '<i class="fa-solid fa-check"></i> Selected';
        btn.closest('.price-card').classList.add('pkg-selected');
        selectedPackage = key;
        updateSummary();
        var optionsSection = document.getElementById('pricing-options');
        if (optionsSection) optionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('.opt-select-btn').forEach(function (btn) {
      var defaultLabel = btn.textContent;
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-addon');
        var label = btn.getAttribute('data-addon-label');
        var card = btn.closest('.po-card');
        var isOn = btn.classList.toggle('is-selected');
        card.classList.toggle('pkg-selected', isOn);
        if (isOn) {
          btn.innerHTML = '<i class="fa-solid fa-check"></i> Added';
          selectedAddons[key] = label;
        } else {
          btn.textContent = defaultLabel;
          delete selectedAddons[key];
        }
        updateSummary();
      });
    });

    // ---- Real cart/checkout: active once the session product is published
    // to the Online Store (see finalBar's data-mode, set in the Liquid template) ----
    if (finalBar.getAttribute('data-mode') === 'commerce') {
      finalClaimBtn.addEventListener('click', function (e) {
        if (!selectedPackage) { e.preventDefault(); return; }
        e.preventDefault();

        var items = [];
        var pkgBtn = document.querySelector('.pkg-select-btn[data-package="' + selectedPackage + '"]');
        var pkgVariantId = pkgBtn && pkgBtn.getAttribute('data-variant-id');
        if (pkgVariantId) items.push({ id: parseInt(pkgVariantId, 10), quantity: 1 });

        document.querySelectorAll('.opt-select-btn.is-selected').forEach(function (b) {
          var vid = b.getAttribute('data-variant-id');
          if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
        });

        if (!items.length) return;

        finalClaimBtn.classList.add('is-loading');
        var originalLabel = finalClaimBtn.innerHTML;
        finalClaimBtn.innerHTML = 'Adding…';

        fetch(finalBar.getAttribute('data-cart-add-url'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) { return res.json().then(function (data) { throw new Error(data.description || 'Cart add failed'); }); }
            return res.json();
          })
          .then(function () {
            window.location.href = finalBar.getAttribute('data-cart-url');
          })
          .catch(function (err) {
            finalClaimBtn.classList.remove('is-loading');
            finalClaimBtn.innerHTML = originalLabel;
            alert(err.message || 'Something went wrong adding this to your cart — please try again.');
          });
      });
    }

    updateSummary();
  }

  /* ---------- Artist Bio Modal ---------- */
  var bioData = {
    'manu-katche': {
      name: 'Manu <span class="fn">Katché</span>',
      text: '<p>Manu Katché is a French drummer and composer renowned for his unique style and versatility. Born into a family of Ivorian origin, his interest in music began at a very young age, first training on the piano before turning to the drums, where he found his true passion.</p>' +
        '<p>Manu made a name for himself in the 1980s, playing with renowned artists such as Peter Gabriel, with whom he recorded the albums &ldquo;So&rdquo; (1986) and &ldquo;Us&rdquo; (1992). His subtle, innovative drumming quickly attracted attention, propelling him onto the international scene. In addition to Peter Gabriel, he collaborated with many other legendary musicians, including Sting, Joni Mitchell, Dire Straits and Tears for Fears.</p>' +
        '<p>Alongside his collaborations, Manu has developed a prolific solo career. He has released several albums under his own name, exploring a variety of genres from jazz to rock. His compositions testify to his talent as a musician and his taste for sound experimentation.</p>' +
        '<p>Renowned for his sense of rhythm and distinctive groove, Manu has also made a name for himself on French television as a juror on the &ldquo;Nouvelle Star&rdquo; show, and through the excellent Arte TV program &ldquo;One Shot Not&rdquo;, an original concept he developed by inviting the greatest artists and international nuggets! As an internationally respected and influential artist, Manu continues to inspire drummers and musicians around the world, sharing his passion and exceptional musical approach.</p>'
    },
    'steve-gadd': {
      name: 'Steve <span class="fn">Gadd</span>',
      text: '<p>Legendary American drummer Steve Gadd is known for his profound influence on contemporary music. From an early age, Steve showed an exceptional aptitude for the drums, beginning lessons at the age of seven under the guidance of his uncle, also a drummer. He continued his musical studies at the Eastman School of Music, where he honed his skills and developed his unique style.</p>' +
        '<p>Steve quickly made a name for himself in the 1970s thanks to his versatility and innovative playing. He became one of the most sought-after studio drummers, collaborating with world-renowned artists such as Paul Simon, with whom he recorded classics like &ldquo;50 Ways to Leave Your Lover&rdquo;, and Steely Dan, on albums such as &ldquo;Aja&rdquo;. His drumming on &ldquo;Aja&rdquo; is particularly celebrated for its complexity and musicality.</p>' +
        '<p>Beyond studio sessions, Steve is also renowned for his live performances with artists such as Eric Clapton, Chick Corea, and James Taylor. His style, characterized by inimitable groove and technical precision, has earned him numerous distinctions and a place in the pantheon of drummers!</p>' +
        '<p>In addition to his collaborations, Steve has led his own bands, exploring various musical genres through personal projects. His impact on modern drumming is immense, and he continues to inspire generations of musicians with his exceptional playing and invaluable contribution to music.</p>'
    },
    'terri-lyne-carrington': {
      name: 'Terri Lyne <span class="fn">Carrington</span>',
      text: '<p>Terri Lyne Carrington is an acclaimed American drummer, composer and producer, known for her significant contribution to jazz and contemporary music. A child prodigy, &ldquo;TLC&rdquo; received her first drum kit at the age of 7 and quickly showed exceptional talent. She received a scholarship to study at the prestigious Berklee College of Music at the age of 11, where she honed her skills and prepared for a brilliant musical career.</p>' +
        '<p>In the 1980s, &ldquo;TLC&rdquo; made a name for herself playing with jazz legends such as Dizzy Gillespie, Stan Getz and Herbie Hancock. She also became the first woman to play on TV&rsquo;s &ldquo;The Arsenio Hall Show&rdquo;. Her versatility and dynamic playing propelled her onto the international scene.</p>' +
        '<p>&ldquo;TLC&rdquo; has released several albums as leader, including &ldquo;Real Life Story&rdquo; (1989) and &ldquo;The Mosaic Project&rdquo; (2011), the latter winning a Grammy Award. She explores themes of social justice and diversity in her work, distinguishing herself by her ability to fuse different musical styles.</p>' +
        '<p>In addition to her performing career, &ldquo;TLC&rdquo; is a dedicated educator, teaching at Berklee College of Music. She is also an influential voice for women in jazz, actively working to promote equality and inclusion in the music industry.</p>' +
        '<p>With a career spanning several decades, &ldquo;TLC&rdquo; continues to inspire and shape the jazz world, making history with her exceptional talent and commitment to music and social justice.</p>'
    },
    'cindy-blackman-santana': {
      name: 'Cindy <span class="fn">Blackman-Santana</span>',
      text: '<p>Cindy Blackman-Santana is an American drummer and bandleader celebrated for her explosive power, technical command and deep jazz roots. Raised in a musical family, she began playing drums as a child and went on to study at the Berklee College of Music and the Hartt School, immersing herself in the language of jazz greats like Max Roach, Elvin Jones and Tony Williams — the drummer who would become her greatest mentor and inspiration.</p>' +
        '<p>In the early 1990s, Cindy relocated to New York, quickly establishing herself on the city&rsquo;s jazz scene while leading her own groups and releasing acclaimed albums as a bandleader. Her career reached a new level of visibility in 1993, when she became the drummer for Lenny Kravitz — a role she held for over two decades, powering some of the era&rsquo;s most iconic rock tours and recordings on stages around the world.</p>' +
        '<p>Since 2010, Cindy has been the drummer for legendary guitarist Carlos Santana, whom she later married, continuing to blend her jazz sensibility with the raw energy of rock and Latin rhythms on some of the biggest stages on Earth.</p>' +
        '<p>A relentless student and teacher of the instrument, Cindy is known for a playing style that is as disciplined as it is fearless — deeply rooted in jazz tradition, yet built to fill arenas. She continues to record and perform as a bandleader, and remains one of the most respected and influential drummers of her generation.</p>'
    },
    'akira-jimbo': {
      name: 'Akira <span class="fn">Jimbo</span>',
      text: '<p>Musical. Exciting. Dynamic. Blazing. Solid. Astonishing. All these words can be used to describe Akira Jimbo. He has been a leading figure in the Japanese music scene for more than 15 years and continues gaining well-deserved international recognition. Although he did not start playing drums until he was 17, Akira has become a master of his art form and is practically a household name in his home country of Japan.</p>' +
        '<p>Akira started playing drums in college (Keio University in Tokyo) and was a member of the Keio Light Music Society, the school&rsquo;s 18-piece big band. In 1980, he became the full-time drummer in the internationally renowned group, Casiopea. In his 10-year tenure with the band, he became recognized for his unique playing style and intricate techniques. With Casiopea, Akira released over a dozen albums, toured the world three times, and quickly established himself as something of a musical phenomenon in Japan. It was during this period that he refined his abilities as a composer and studio artist. After Casiopea, Akira formed Jimsaku in 1989 to explore new and different musical possibilities.</p>' +
        '<p>Along with the groups with whom he has performed and recorded, Akira has also maintained a high profile in the area of solo album work. He has released over 10 solo albums to date such as &ldquo;Palette&rdquo; (1991), &ldquo;Slow Boat&rdquo; (1992), &ldquo;Lime Pie&rdquo; (1994), &ldquo;Panama Man&rdquo; (1995) and &ldquo;Flower&rdquo; (1997).</p>' +
        '<p>His solo performances are now legendary. Akira can play both an acoustic and electronic kit simultaneously, which is a huge advantage over other clinicians who only follow a sequence of backing tracks. He loves complexity, but he also knows how to make music that feels good, much like Steve Gadd, his mentor!</p>' +
        '<p>In addition to studio and solo projects, he has also released four instructional videos through DCI Music Video/Warner Bros. Publications: &ldquo;Metamorphosis&rdquo; (1992), &ldquo;Pulse&rdquo; (1995), &ldquo;Independence&rdquo; (1998) and &ldquo;Evolution&rdquo; (1999). Throughout his career, Akira Jimbo has used Yamaha drums and electronics exclusively for over 30 years as tools to channel his creative energy.</p>'
    },
    'dave-weckl': {
      name: 'Dave <span class="fn">Weckl</span>',
      text: '<p>Another Jazz Fusion legend, Dave Weckl is a world-renowned American drummer, renowned for his technical playing, rhythmic precision and influence on jazz fusion and more contemporary playing. From an early age, Dave showed a keen interest in drumming, and began playing professionally in his teens.</p>' +
        '<p>Dave came to prominence in the 1980s through his collaboration with saxophonist Michael Brecker and the jazz fusion group Chick Corea Elektric Band. His dynamic, innovative playing attracted attention, and he quickly became one of the most sought-after drummers of his generation. He has recorded with many renowned artists, including Paul Simon, Madonna, George Benson, and Steely Dan.</p>' +
        '<p>In 1990, Dave launched his own solo career with the album &ldquo;Master Plan&rdquo;, which was exceptionally well received by critics and audiences alike — an album that has become a cult classic among drummers! He continues to explore diverse musical styles, from jazz fusion to rock, demonstrating his versatility and adaptability.</p>' +
        '<p>In addition to his talents as a drummer, Dave is also a passionate educator, sharing his knowledge through masterclasses, workshops and instructional videos. He is also renowned for his work as a composer and producer, collaborating with diverse musicians to create innovative and inspiring albums.</p>' +
        '<p>Dave continues to influence generations of drummers with his technical playing, sense of groove and limitless creativity, cementing his place among the great drummers in the history of modern music.</p>'
    },
    'keith-carlock': {
      name: 'Keith <span class="fn">Carlock</span>',
      text: '<p>Keith Carlock is a highly acclaimed American session and touring drummer. He is widely known for his unique style and ability to seamlessly blend various genres of music. Keith has recorded and/or toured with such musical luminaries as Steely Dan, John Mayer, Sting, James Taylor, Toto, Christopher Cross, Donald Fagen, Walter Becker, Diana Ross, Faith Hill, The Blues Brothers, Wayne Krantz, Mike Stern, Robben Ford, Bill Evans, Leni Stern, David Johansen, Richard Bona, Chris Botti, Rudder, Harry Belafonte, Oz Noy, Larry Carlton, Clay Aiken, Rascal Flatts, Paula Abdul, Eros Ramazzotti, Bootsy Collins, Michael Bublé and Grover Washington, Jr, to name only a few.</p>' +
        '<p>Keith has been the drummer with iconic jazz-rock band Steely Dan for over 20 years. He has performed on every tour since 2003, and his first recording with them, &ldquo;Two Against Nature&rdquo;, won the Grammy Award for &ldquo;Album Of The Year&rdquo; in 2001.</p>' +
        '<p>Keith was honored to be voted the winner in the Pop, Fusion, and Best All-Around categories in Modern Drummer magazine&rsquo;s 2009 Readers Poll. He was also voted the winner in the Jazz category in 2010, and the Pop category in 2008. Keith has been inducted into the Mississippi Musicians Hall Of Fame.</p>' +
        '<p>Keith&rsquo;s instructional DVD with Hudson Music is entitled &ldquo;Keith Carlock — The Big Picture: Phrasing, Improvisation, Style &amp; Technique&rdquo;.</p>' +
        '<p>Keith endorses Gretsch drums, Zildjian cymbals, Vic Firth sticks, Evans drum heads, DW hardware, LP percussion, and Earthworks microphones.</p>'
    },
    'roni-kaspi': {
      name: 'Roni <span class="fn">Kaspi</span>',
      text: '<p>Roni Kaspi, who is only 22 years old, has been turning plenty of heads since her breakout in 2020 as touring drummer for the Avishai Cohen Trio, the global sensation of jazz bass. Having started on the drums at age 7 (&ldquo;I actually think the drums chose me, not the other way around,&rdquo; she says), Roni was mentored at the prestigious Berklee College of Music by Terri Lyne Carrington, the Grammy-winning drumming maestro, before being thrust into the spotlight when fellow Israeli Avishai Cohen recruited her into his celebrated trio after hearing her phenomenal playing on a video posted to Instagram. Filling the stool of drummers as influential as Mark Guiliana, on top of a packed international touring schedule, she also played a central role on &ldquo;Shifting Sands,&rdquo; one of the Avishai Cohen Trio&rsquo;s finest recordings to date, which stormed international charts throughout 2022.</p>' +
        '<p>As incredible as that has been — and it changed her life — it is only one facet of the singular, wide-ranging musical world of the Israeli-born artist, who also steps out as a singer-songwriter behind the kit and a producer, leading her own instrumental-and-songs project that is at once forward-thinking, groovy and accessible. &ldquo;These past two years, I&rsquo;ve been working on my own music. These songs are my true musical identity,&rdquo; she says. For her trio project, Roni brings an ultra-hip, all-encompassing vision that pushes genre boundaries, daring to blend the futuristic with the traditional, funky &ldquo;in-the-moment&rdquo; improvisation with eclectic influences from alt-pop, soul, world music and electronica — though there are more differences than similarities, think Thundercat, Anderson .Paak, Louis Cole and Björk. &ldquo;Everything inspires me: musicians, actors, creators, people in general — everywhere, all the time,&rdquo; she says. &ldquo;There are certain musicians — Tony Williams is, to me, a master of the instrument and a channel for musical energy. Miles Davis is an example of an artist who never stopped searching for new things. Then David Hockney, Andy Warhol and plenty of others.&rdquo;</p>' +
        '<p>With her spellbinding creativity, free-wheeling playing, eccentric voice and candid lyrics, Roni is joined by a Paris-based trio featuring Oxy, an incredibly inventive genius on analog keys and synths, and Noé Berne on silky, funky electric bass. Youthful, indie-rock-and-hip-hop attitude meets the sophistication of jazz in an inclusive mix built for today&rsquo;s listeners — naturally curious and open-minded. The Roni Kaspi Trio is proof that jazz is no longer just your parents&rsquo; music, but one of the many special ingredients on the playlist of every switched-on young artist, making music that expresses the moment we&rsquo;re living in.</p>'
    }
  };

  var bioOverlay = document.querySelector('.bio-modal-overlay');
  if (bioOverlay) {
    var bioModal = bioOverlay.querySelector('.bio-modal');
    var bioNameEl = bioOverlay.querySelector('.bio-modal-name');
    var bioTextEl = bioOverlay.querySelector('.bio-modal-text');
    var bioCloseBtn = bioOverlay.querySelector('.bio-modal-close');

    function openBioModal(key) {
      var data = bioData[key];
      if (!data) return;
      bioNameEl.innerHTML = data.name;
      bioTextEl.innerHTML = data.text;
      bioOverlay.classList.add('is-open');
      if (bioModal) bioModal.scrollTop = 0;
      document.body.style.overflow = 'hidden';
    }
    function closeBioModal() {
      bioOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-bio]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openBioModal(btn.getAttribute('data-bio'));
      });
    });
    if (bioCloseBtn) bioCloseBtn.addEventListener('click', closeBioModal);
    bioOverlay.addEventListener('click', function (e) {
      if (e.target === bioOverlay) closeBioModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeBioModal();
    });
  }

});
